import { IConfig } from '@cian/config/shared';

import { ECategory } from '../../../../../shared/repositories/monolith-python/entities/offer/OfferSchema';
import { EBusinessType } from '../../../../../shared/types/businessType';
import { businessSubTypes } from '../../enums/commercial-object-types';

import { IAddFormService } from '../addFormService';

import { IBusinessService, IReadyBusinessTypeOption } from './types';

export const businessService = (config: IConfig, addFormService: IAddFormService): IBusinessService => {
  'ngInject';
  const svc = {} as IBusinessService;

  svc.isCommercialBusinessAvailable = () => {
    const category = addFormService.getFieldValue<ECategory>('category');
    const isBusinessSale = category === ECategory.BusinessSale;

    return isBusinessSale;
  };

  svc.getReadyBusinessTypeOptions = (): IReadyBusinessTypeOption[] => businessSubTypes;

  svc.changeReadyBusinessType = type => addFormService.setValueByPath('readyBusinessType', type);

  svc.getReadyBusinessType = () => addFormService.getFieldValue<EBusinessType>('readyBusinessType');

  svc.getReadyBusinessTypeSelected = () => {
    const readyBusinessType = svc.getReadyBusinessType();

    if (svc.isCommercialBusinessAvailable()) {
      return !!readyBusinessType;
    }

    return true;
  };

  svc.setExactAddress = value => addFormService.setValueByPath('isNeedHideExactAddress', value);

  svc.getAvalaibleSpecialiesCount = () => {
    const businessType = svc.getReadyBusinessType();

    if (businessType === EBusinessType.RentalBusiness) {
      return 5;
    }

    return 1;
  };

  svc.getSpecialitiesLabel = () => {
    const businessType = svc.getReadyBusinessType();

    if (businessType === EBusinessType.RentalBusiness) {
      return 'Выберите не более 5 вариантов назначения помещения';
    }

    return 'Выберите 1 подходящее назначение помещения';
  };

  svc.onReadyBusinessTypeChange = () => {
    addFormService.setValueByPath('building.floorsCount', undefined);
    addFormService.setValueByPath('conditionType', undefined);
    addFormService.setValueByPath('specialty', undefined);
  };

  return svc;
};
